import { ApiFilterTable } from "./ApiFilterTable.js";
import { ApiFieldTable } from "./ApiFieldTable.js";

/** "/api/datasets/{id}/" -> ["/api/datasets/", <span>{id}</span>, "/"] */
function renderPath(path) {
  return path.split(/(\{[^}]+\})/).map((part, i) =>
    /^\{.*\}$/.test(part) ? <span className="apiOpPathParam" key={i}>{part}</span> : part
  );
}

/**
 * One resource: eyebrow + title + description, its operation rows, then the list
 * operation's filters and the response fields. `children` render right after the op rows
 * so the page can inline the response panel there on narrow layouts.
 */
export function ApiResourceSection({ resource, groupLabel, activeOpId, onSelectOp, sectionRef, typeNames, children }) {
  const listOp = resource.listOp || resource.operations[0];
  const titleId = `${resource.id}-title`;

  return (
    <section className="apiResource" id={resource.id} aria-labelledby={titleId} ref={sectionRef}>
      <div className="apiResourceHeader">
        <span className="apiEyebrow">{groupLabel}</span>
        <h2 className="apiResourceTitle" id={titleId}>{resource.label}</h2>
        {resource.description && <p className="apiBody">{resource.description}</p>}
      </div>

      <div className="apiOpList">
        {resource.operations.map((op) => {
          const active = op.id === activeOpId;
          return (
            <button
              type="button"
              key={op.id}
              className={active ? "apiOpRow apiOpRowActive" : "apiOpRow"}
              data-op-id={op.id}
              aria-pressed={active}
              onClick={() => onSelectOp(op)}
            >
              <span className="apiOpMethod">{op.method}</span>
              <span className="apiOpPath">{renderPath(op.path)}</span>
              <span className="apiOpLabel">{op.label}</span>
            </button>
          );
        })}
      </div>

      {children}

      {listOp && (
        <div className="apiTableBlock">
          <div className="apiSubheadRow">
            <h3 className="apiSubhead">
              Filters
              {listOp.filters.length > 0 && <span className="apiCount">{listOp.filters.length}</span>}
            </h3>
            {listOp.filters.length > 0 && (
              <a className="apiTextLink" href="#grammar">How suffixes work</a>
            )}
          </div>
          <ApiFilterTable filters={listOp.filters} idPrefix={resource.id} />
        </div>
      )}

      {listOp && listOp.fields.length > 0 && (
        <div className="apiTableBlock">
          <h3 className="apiSubhead">List returns</h3>
          <ApiFieldTable fields={listOp.fields} typeNames={typeNames} />
        </div>
      )}

      {resource.detailOp && resource.detailOp.fields.length > 0 && (
        <div className="apiTableBlock">
          <h3 className="apiSubhead">Detail returns</h3>
          <ApiFieldTable fields={resource.detailOp.fields} typeNames={typeNames} />
        </div>
      )}
    </section>
  );
}
